import { get } from '../tools/http';

const formatReports = dataGroups => {
    dataGroups.data.forEach(itemGroup => {
        if ((itemGroup.reports != null) && (itemGroup.reports.length > 0)) {
            itemGroup.reports.forEach(itemreport => {
                itemreport.createdAtDate = itemreport.createdAt.substring(8,10) + '.' + itemreport.createdAt.substring(5,7) + '.' + itemreport.createdAt.substring(0, 4) + ' г.';
                itemreport.createdAtTime = itemreport.createdAt.substring(11,16);
            });
            itemGroup.reports.sort(function(a,b){ return new Date(b.createdAt) - new Date(a.createdAt); });
        }
    });
};

export default {
    state: {
        reports: [],
        achievements: [],
    },
    mutations: {
        setReportsData: (state, data) => {
            state.reports = data;
        },
        setAchievements: (state, data) => {
            state.achievements = data;
        },
    },
    actions: {
        loadReports: async ctx => {
            if (!ctx.rootGetters.user.id) return;

            let dataGroups = await get('reporting', 'api/v1/report/listreportgrouped', null, true);
            if ((dataGroups != null) && (dataGroups.data != null) && (dataGroups.data.length > 0)) {
                formatReports(dataGroups);
                ctx.commit('setReportsData', dataGroups.data);
            }else{
                ctx.commit('setReportsData', []);
            }
        },
        loadAchievements: async ctx => {
            const achievementGroups = await get('reporting', 'api/v1/report/listachievementgrouped', null, true);
            if (achievementGroups && achievementGroups.data) {
                formatReports(achievementGroups);
                ctx.commit('setAchievements', achievementGroups.data);
            }else{
                ctx.commit('setAchievements', []);
            }
        },
        loadAchievementsByUserId: async (ctx, userId) => {
            const achievementGroups = await get('reporting', `api/v1/report/listgrouped/${userId}`, null, true);
            return achievementGroups && achievementGroups.data ? achievementGroups.data : [];
        },
        loadReportTypes: async (ctx, withGroup = false) => {
            let path = 'api/v1/reporttype';

            if (withGroup) {
                path += '?withGroup=true';
            }

            const achievementGroups = await get('reporting', path, null, true);
            return achievementGroups && achievementGroups.data ? achievementGroups.data : [];
        },
        loadReportGroups: async (ctx, withTypes = false) => {
            let path = 'api/v1/reportgroup';

            if (withTypes) {
                path += '?withTypes=true';
            }

            const achievementGroups = await get('reporting', path, null, true);
            return achievementGroups && achievementGroups.data ? achievementGroups.data : [];
        },

    },
    getters: {
        reports: state => state.reports,
        achievements: state => state.achievements,
    },
};
